import { useCallback } from "react";
import { Box, Typography } from "@mui/material";
import { ResponsiveContainer, LineChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Line } from "recharts";
import { RechartsLineChartProps } from "../../payment.types";

const CustomizedLegend = (props: any) => {
  const { payload } = props;
  return (
    <Box
      component="ul"
      sx={{
        listStyle: "none",
        padding: 0,
        margin: "20px 0 0",
        display: "flex",
        justifyContent: "flex-end",
        columnGap: "24px",
      }}
    >
      {payload.map((entry: any, index: number) => (
        <Box
          component="li"
          key={`item-${index}`}
          sx={{
            display: "flex",
            alignItems: "center",
            columnGap: "8px",
          }}
        >
          <Box
            sx={{
              width: "20px",
              borderBottom: `${entry.payload.strokeWidth}px ${entry.payload.strokeDasharray ? "dashed" : "solid"} ${
                entry.payload.stroke
              }`,
            }}
          />
          <Typography
            component="span"
            sx={{
              color: "#67696B",
              fontFamily: "Montserrat",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "20px",
            }}
          >
            {entry.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

const RechartsLineChart = ({ data, lines, legend = true }: RechartsLineChartProps) => {
  const currency = data[0]?.currency ? data[0].currency.toUpperCase() : "";

  const formatYAxisTick = useCallback(
    (value: number) => {
      let formattedValue = "";
      if (value >= 1000000) {
        formattedValue = `${(value / 1000000).toFixed(1).replace(/\.0$/, "")}M`;
      } else if (value >= 1000) {
        formattedValue = `${(value / 1000).toFixed(1).replace(/\.0$/, "")}K`;
      } else {
        formattedValue = value.toString();
      }
      return `${formattedValue} ${currency}`;
    },
    [currency]
  );

  return (
    <ResponsiveContainer width="100%" height={240}>
      <LineChart data={data} margin={{ top: 5, right: 20, left: 20, bottom: 5 }}>
        <CartesianGrid
          strokeDasharray="4 4"
          strokeWidth="1.2"
          strokeLinecap="round"
          stroke="#DCDCE6"
          vertical={false}
        />
        <XAxis
          dataKey="day"
          width={1}
          stroke="#84818D"
          tickMargin={20}
          tick={{
            fill: "#84818D",
            fontFamily: "Montserrat",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 500,
          }}
        />
        <YAxis
          axisLine={false}
          tickLine={false}
          orientation="right"
          tick={{
            fill: "#84818D",
            fontFamily: "Montserrat",
            fontSize: 12,
            fontStyle: "normal",
            fontWeight: 500,
          }}
          tickFormatter={formatYAxisTick}
        />
        {legend && <Legend content={<CustomizedLegend />} />}
        {lines.map((line, index) => (
          <Line
            key={index}
            type="monotone"
            dataKey={line.dataKey}
            stroke={line.stroke}
            strokeWidth={2}
            strokeDasharray={line.strokeDasharray}
            dot={false}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
};

export default RechartsLineChart;
